import * as Yup from 'yup';

export const validatePassword = () => {
  return Yup.string().trim().required('*Required');
};
